export class ApiResponse<T> {
    message!: string;
    data!: T;
    // statusCode!: number;
    isSuccess!:boolean;
  }

  export class PaginatedResult<T>{
    page?: number;
    pageSize?: number;
    total?: number;
    data?: T[] = [];
    hasNext?:boolean;
}

export class PaginatedItem<T>{
  page?: number;
  pageSize?: number;
  total?: number;
  data?: T;
  hasNext?:boolean;
}

export class KeyValue{
  key!:string;
  value!:string | number
}

export class ConversionResponse {
  quota!: number;
  isSubscriptionActive!: boolean;
  outOfQouta!:boolean;
  url!: string;
  isUserOrIPExceedingDownloads!:boolean;
  hasIntroSubscription!:boolean;
  alreadyDownloaded!:boolean;
}
export class ZipConversionResponse {
  quota!: number;
  isSubscriptionActive!: boolean;
  outOfQouta!:boolean;
  // zip?: ZipFileResponse;
  isUserOrIPExceedingDownloads!:boolean;
  hasIntroSubscription!:boolean;
  alreadyDownloaded!:boolean;
}
export class ZipFileResponse{
   fileName!:string;
   contentType!:string;
   base64Data!:string;
}
